module.exports = __webpack_public_path__ + "img/1.dc086c4.png";